"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSContractTarget_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSContractTarget_Factory = /** @class */ (function () {
    function NHSContractTarget_Factory() {
    }
    NHSContractTarget_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            MembershipId: model.MembershipId,
            PeriodMonthId: model.PeriodMonthId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UDATarget: model.UDATarget,
            UOATarget: model.UOATarget,
        };
        return result;
    };
    NHSContractTarget_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            MembershipId: model.MembershipId,
            PeriodMonthId: model.PeriodMonthId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UDATarget: model.UDATarget,
            UOATarget: model.UOATarget,
        };
        return result;
    };
    return NHSContractTarget_Factory;
}());
exports.NHSContractTarget_Factory = NHSContractTarget_Factory;
